import axiosInstance from '../../../api/axiosConfig';

export interface NotificationPreference {
    id: number;
    userId: number;
    emailSiteMonitoring: boolean;
    emailCampaignReport: boolean;
    emailDailyPerformance: boolean;
    emailWeeklyReport: boolean;
    emailSiteDown: boolean;
}

export const getNotificationPreferences = async (): Promise<NotificationPreference> => {
    const { data } = await axiosInstance.get('/notification-preferences');
    return data;
};

export const updateNotificationPreferences = async (
    prefs: Partial<NotificationPreference>
): Promise<NotificationPreference> => {
    const { data } = await axiosInstance.patch('/notification-preferences', prefs);
    return data;
};
